<div class="favorites-icon">
  <span class="favorites-icon__number" *ngIf="favoriteItemsNumber > 0">{{favoriteItemsNumber}}</span>
  <brt-icon [icon]="'bookmark-full'"></brt-icon>
</div>
